import React, { useEffect, useState } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Autocomplete,
  TextField,
  Box,
  Grid,
  Typography
} from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import DeleteIcon from '@mui/icons-material/Delete'
import Switch from '@mui/material/Switch'
import {
  ApiGetAllRoles,
  ApiGetAdminList,
  ApiPutUpdateAdminRole,
  ApiPutUpdateAdminStatus,
  ApiGetManageRegions,
  ApiPutRegion
} from '../../../apiService/Core/Apicall.tsx'
import { toast } from 'react-toastify'
const ManageRegions: React.FC = () => {
  const [regionList, setRegionList] = useState<any>([])
  const [roles, setRoles] = useState<any>([])
  const navigate = useNavigate()

  useEffect(() => {
    const fetchData = async () => {
      await handleGetApiCall()
    }
    fetchData()
    return () => { }
  }, [])

  const handleGetApiCall = async () => {
    const data = '?offset=0&limit=100'
    try {
      const response: any = await ApiGetManageRegions()
      setRegionList(response.data)
    } catch (error) {
      console.error('Error during API call:', error)
    }
  }

  const addOrUpdateRegion = (region?: any) => {
    if (region) {
      navigate(`/admin/add-or-update-region/update/${region.regionId}`, {
        state: { region: region },
      })
    } else {
      navigate('/admin/add-or-update-region/add')
    }
  }

  const handledeleteregion = async (regionId) => {
    try {
      const FormData = {
        regionId: regionId,
        isActive: false,
        modifiedBy: Number(localStorage.getItem("createdBy")),
      };
      const response: any = await ApiPutRegion(FormData);
      toast.success("Region updated successfully!");
      handleGetApiCall()
    } catch (error) {
      toast.error(error)
    }
  }
  return (
    <div className='w-100 p-2'>
      <Box className='bg-light px-2 py-3 border-10'>
        <Grid container className='w-100 mb-4' gap={{ xs: 3, md: 0 }}>
          <Grid size={{ xs: 12, md: 'grow' }}>
            <Typography className='text-center fs-42'>Manage Regions</Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 'auto' }}>
            <div className='d-flex justify-content-end'>
              <Link
                to={`/admin/add-or-update-region/add`}
                // variant='contained'
                // onClick={() => addOrUpdateRegion()}
                className='table-row-background  link-btn'
              >
                Add New Region
              </Link>
            </div>
          </Grid>
        </Grid>
        <Box className='w-100' overflow={'auto'}>
          <Table>
            <TableHead>
              <TableRow className='table-row-background'>
                {["Id", "Region Name"].map((item, index) => (<TableCell key={index} style={{ color: '#fff' }}>{item}</TableCell>))}
                <TableCell style={{ color: '#fff' }}>Edit</TableCell>
                <TableCell style={{ color: '#fff' }}>Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* {adminUsers?.map(user => (
            <TableRow key={user.id}>
              <TableCell>
                <Button
                  variant='contained'
                  onClick={openEditAccessGroup}
                  className='table-row-background'
                >
                  Group
                </Button>
              </TableCell>
              <TableCell>{user.displayName}</TableCell>
              <TableCell>{user.userName}</TableCell>
              <TableCell>****</TableCell>
              <TableCell>{user.emailId}</TableCell>
              <TableCell>
                <div className='w-200'>
                  <Autocomplete
                    options={typeOptions.filter((_, index) => index < 3)}
                    value={typeOptions.find(
                      option => option.label === user.role.roleDisplayName
                    )}
                    getOptionLabel={option => option.label}
                    onChange={(event, newValue) =>
                      handleTypeChange(event, newValue, user.userId)
                    } 
                    renderInput={params => (
                      <TextField {...params} label='Type' />
                    )}
                    fullWidth
                  />
                </div>
              </TableCell>

              <TableCell>
                <div className='switch-admin'>
                  <Switch
                    checked={user?.userStatus?.userStatus === 'active'}
                    onChange={e => {
                      const newStatus = e.target.checked ? 'active' : 'inActive'
                      handleChange(user, newStatus)
                    }}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </div>
              </TableCell>

              <TableCell>
                <Button
                  variant='contained'
                  onClick={() => addOrUpdateAdmin(user.userId)}
                  className='table-row-background'
                >
                  Edit
                </Button>
              </TableCell>
              <TableCell>
                <Button variant='contained' className='delete-transparent'>
                  <DeleteIcon className='delete-icon' />
                </Button>
              </TableCell>
            </TableRow>
          ))} */}
              {regionList?.map(region => (
                <TableRow key={region.regionId}>
                  <TableCell>{region.regionId}</TableCell>
                  <TableCell>{region.regionName}</TableCell>
                  <TableCell>
                    <Link
                     to={`/admin/add-or-update-region/update/${region.regionId}`}
                      // variant='contained'
                      // onClick={() => addOrUpdateRegion(region)}
                      className='table-row-background link-btn'
                    >
                      Edit
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Button variant='contained' onClick={() => { handledeleteregion(region?.regionId) }} className='delete-transparent'>
                      <DeleteIcon className='delete-icon' />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </div>
  )
}

export default ManageRegions
